import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import '../home/main.scss';
import HomeSidebar from './_sidebar';
import HomeContent from './_content';

const Home = props => (
  <div className="main">
    <div className="main-sidebar">
      <HomeSidebar/>
    </div>
    <div className="main-content">
      <HomeContent/>
    </div>
  </div>
);

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
